<template>
    <div v-if="currentProductDetail!==null" class="product-container">
        
        <!-- Product header -->
        <div class="product-title center">
        <div>
            <h3>INICIO <span v-for="(data, index) in currentProductDetail.categories" :key="index"> > {{data.name.toUpperCase()}}  </span> </h3>
        </div>
            <h1>{{currentProductDetail.name}}</h1>
        </div>

        <div class="product-item mobile">
                <h1 class="availability" v-if="currentProductDetail.available===true">Disponibilidad: {{currentProductDetail.availability}} </h1>
                <h1 class="availability not-available" v-else>No disponible</h1>
                <h1 class="price-header">${{currentProductDetail.basePrice | numeral('0.00')}}</h1>
         </div>
        <!-- Product body -->
        <div class="product-body  center">
            <div class="product-item columns">
                <img  class="product-image" onerror="this.src='https://images.gofarma.com.mx/fallback.jpeg';" :alt="currentProductDetail.name" :src="'https://images.gofarma.com.mx/'+currentProductDetail.sku+'-1.jpeg'" >
            </div>

            <div class="product-item" >
                <div class="web">
                    <h1 class="availability" v-if="currentProductDetail.available===true">Disponibilidad: {{currentProductDetail.availability}} </h1>
                    <h1 class="availability not-available" v-else>No disponible</h1>
                    <h1 class="price-header">${{currentProductDetail.basePrice | numeral('0.00')}}</h1>
                </div>
                 <!--<div class="product-sub-container space-between">
                    <h1 class="price-header product-discount">  <span> SOLO HOY</span> <span> ${{currentProductDetail.basePrice | numeral('0.00')}}</span>  </h1>
                    <h2 align="left" class="light-gofarma"><b>SOLO HOY</b></h2>
                    <h2 class="cost-align"><b>$296.10</b></h2>
                </div>-->


                <div class="product-sub-container center columns">
                    <div class="product-body center space-between" style="margin-bottom: 1em;">
                        <div class="number-input">
                            <button @click="AddProductQuantity" name="remove" data-amount="-1">-</button>
                            <input type='number' v-bind:value='quantity' @change="SetProductQuantity"/>
                            <button @click="AddProductQuantity" name="add" data-amount="1">+</button>
                        </div>
                        <button class="ui primary button gofarma-bg-blue wide detail-button cart-button" @click="AddRawProduct( {product: {id: currentProductDetail.id}, quantity: quantity} )">AGREGAR AL CARRITO</button>
                    </div>
                    <button v-if="currentCustomer" class="ui strong button gofarma-bg-blue wide detail-button" type="button" @click="AddToFavorite(currentProductDetail.id)">Agregar a mi botiquin</button>
                </div>

                <div class="product-sub-container">
                    <div class="product-item" >
                        <p class="order-info">Todos los pedidos realizados son de pago<br>contra entrega</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
    name:'ProductDetail',
    mounted(){
        if(!this.currentProductDetail){
            this.$store.dispatch('GetProductBySlug',this.$route.params.slug)
        }
    },
    data(){
      return {
        quantity: 0
      };
    },
    methods:{
        /**
         * @param e
         * @constructor
         */
        AddProductQuantity(e) {
            let amount = e.target.dataset.amount | 0;
            this.quantity += amount;
        },
        /**
         * Sets product quantity
         * @constructor
         */
        SetProductQuantity(e){
            this.quantity = e.target.value;
        },
        ...mapActions(['AddToFavorite','AddOrRemoveQuantity','AddRawProduct'])
    },
    computed:{
        ...mapState(['currentProductDetail','currentCustomer'])
    }
}
</script>

<style scoped>
@import '../variables.css';
.product-container{
    display: flex;
    justify-content: center;
    padding:2em;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;
}

.product-image{
    width:25rem;
    height:25rem;
}

.product-discount{
   display:flex; 
   justify-content: space-between;
   font-size: 1rem;
}


.product-image-description{
    color: var(--dark-gofarma);
    font-size: 1em;
    text-wrap: normal;
    max-width: 50%;
}
.product-body {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-flow: row;
    flex-flow: row;
}

.product-title{
    width: 70%;
}

.product-title h1{
    font-weight: bold;
    font-size: 1.5em;
    text-align: start;
}

.product-sub-container{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}
.product-item{
    flex-grow: 1;
    margin: 1em;
}
.item-space{
    margin-right:20em;
    margin-left:10em
}
.dark-gofarma{
    color:var(--dark-gofarma);
}
.light-gofarma{
    color:var(--light-gofarma);
}
.align-end{
    align-self:center;
}
.availability{
    background:rgb(243, 243, 243);
    text-align:right;
    color:var(--light-blue);
    font-size: 1.5em;
    font-weight: bold;
    padding: .2em 1em .2em .2em;
}

.not-available{
    color:var(--danger)
}
.price-header{
    margin-top: 1em;
    margin-bottom: 1em;
    font-size: 1.8em;
    text-align:right;
    color: var(--dark-gofarma);
    font-weight: bolder;
    font-family: sans-serif;
}
.detail-button{
    float: right;
}
.detail-button.strong{
     width: 100%;
}
.order-info{
    text-align:justify;
    color:var(--dark-gofarma);
}
.cart-button{
    width: 70%; 
    margin: auto;
}

.quantity-selector{
    width: 100%;
}
@media screen and (min-width: 79.375rem){
    .mobile{
        display: none;
    }
}

@media screen and (max-width: 79.375rem){
    .item-space {
    margin:0rem
    }

    .web{
        display: none;
    }

    .price-header, .product-item{
        margin: 0;
    }

    .detail-button{
        width: 100%
    }

    .product-item button{
        width: 100%
    }
    .detail-button{
        width: 100%
    }
    .quantity-selector{
        width: 90%;
        margin-bottom: 1rem;
    }

    .product-body{
        flex-direction: column;
        width: 100%;
    }
    .product-image{
        width:12.5rem;
        height:12.5rem;
    }
    .number-input{
        width: 50%;
        margin-bottom:0.625rem;
    }

    h3,.product-title h1{
        font-size: 1rem !important;
    }
    .product-container{
        width: 80%;
    }

}
</style>
